/**
 * @file 项目相关类型
 */
import { WalletType } from '@web3/base-utils';
import { ChainInfo } from './wallet';

export enum PromotionStatus {
  YES = 1,
  NO = 2,
}

export enum TaskType {
  FOLLOW = 'follow',
  SHARE = 'forward',
  EXPLORE = 'explore',
}

export type TaskInfo = {
  name: number;
  taskId: number;
  taskStatus: boolean;
  taskType: TaskType;
  twitterCode?: string;
};

export type GetProjectDetailParams = {
  activityCode?: string;
  walletId?: string;
  walletType?: WalletType;
  name: string;
  userId?: string;
};

export type TimeInfo = {
  start: number;
  end: number;
  top: number;
};

export type DexTradeRules = {
  // 低
  l: string;
  // 高
  h: string;
  // 分
  p: number;
  // 概率
  rate: number[];
};

export type ProjectData = {
  projectId: string;
  icon: string;
  name: string;
  desc: string;
  rank: string;
  preRank: string;
  status: PromotionStatus;
  rankChange: string;
  track: string;
  chains: ChainInfo[];
  point: number;
  todayAddPoint: number;
  joinUserCount: number;
  todayAddJoinUserCount: number;
  totalLotteryCount: number;
  taskPoint: number;

  spotTradePointChange: number;
  spotTradePointRank: number;
  hidePoint: number;
  initPoint: number;
  taskStatus: boolean;
  projectTimeList: TimeInfo[];
  dexTradeRules: DexTradeRules[];
  lotteryStatus: boolean;
  pairs: string[];
  tutorial: string;
  tasks: TaskInfo[];
  todayJoinUserCount: number;
  remainLotteryCount: number;
  userPointRank: number;
  userPointChange: number;
  userProjectPoint: number;
  userProjectPointChange: number;
  userDexProAmount: string;
  website: string;
  mediaUrl: string;
  dappUrl: string;
  start: number;
  end: number;
  timeNow: number;
  bbsolHoding: string;
  bbsolHodingPoint: number;
  spotBbsolHoding: string;
  spotBbsolHodingPoint: number;
  spotTradeAmount: string;
  spotTradePoint: number;
  remainPoint: number;
  totalPoint: number;
};

export type GetProjectDetailRes = ProjectData;

export type GetUserRankAddressParams = {
  projectId: string;
  activityCode?: string;
};

export type UserRankInfo = {
  walletId: string;
  walletType: WalletType;
  address: string;
  dexProTradeAmount: string;
  point: number;
  index?: number;
  email?: string;
};

export type GetUserRankAddressRes = UserRankInfo[];

export type PostCompleteTaskParams = {
  taskId: number;
  walletId?: string;
  walletType?: WalletType;
  userId?: string;
  twitterToken?: string;
  walletAddress?: string;
  projectId: string;
  activityCode?: string;
};

export type PostCompleteTaskRes = {};

export type GetPointsParams = {
  activityCode?: string;
  walletId?: string;
  walletType?: WalletType;
  userId?: string;
  projectId: number;
};

export type GetPointsRes = {
  remainPoint: string;
  votingPoint: string;
  rank: string;
  remainLotteryCount: string;
};

export type PostVoteParams = {
  activityCode?: string;
  walletId?: string;
  walletType?: WalletType;
  userId?: string;
  point: number;
  projectId: string;
};

export type PostVoteRes = {};

export type postLotteryParams = {
  activityCode?: string;
  userId?: string;
  walletId?: string;
  walletType?: WalletType;
  walletAddress?: string;
  projectId: string;
};

export type LotteryInfo = {
  rewardAmount: string;
  rewardToken: string;
};

export type postLotteryRes = LotteryInfo;

export enum ModalType {
  NONE,
  VOTE,
  VOTE_RESULT,
  REWARD_RESULT,
}
